import { Link } from 'found'
import { Helmet } from 'react-helmet'
import React, { Component } from 'react'
import { createFragmentContainer } from 'react-relay'
import graphql from 'babel-plugin-relay/macro' 
import LazyLoad from 'react-lazy-load';

import { msToReadingTime } from '../../utils'

import greyTimeIcon from '../../images/grey_time.svg'
// import artboardImage from '../../images/Artboard-41-copy-2.svg'

function ArticlePreview({ link, title, caption, readingTime, author, picture, color, category, parentCategory }) {

    return (
        <div className="column-35 w-col w-col-4">
            <Link
                to={link}
                className="link-block-9 w-inline-block"
            />
            <img alt="" src={picture} className="image-headline primary" />
            <div className="div-block-16 busines" style={{ background: color }} />
            <div>
                <h3 className="heading-22 healdine">
                    {parentCategory !== category.slug &&
                        <span className="span2 subcategory" style={{ textTransform: 'uppercase' }}>
                            {category.name}&nbsp;
                        </span>
                    }
                    {title}
                </h3>
                <p className="paragraph-3">{caption}</p>
            </div>
            <div className="div-block-15">
                <div className="grey">{author.firstname} {author.lastname}</div>
                <img alt="" src={greyTimeIcon} width={13} height={13} className="image-24" />
                <div className="grey2">{msToReadingTime(readingTime)}</div>
            </div>
        </div>
    )
}

class CategoryPage extends Component {

    constructor() {
        super()
        this.state = { rows: 2, isDropdownOpen: false, isHoverDiscoverMore: false }
    }

    render() {
        const { slug, name, color, picture, link, subcategories, articles, seo, social } = this.props
        const canLoadMore = articles.length > this.state.rows * 3
        console.log('unused:',link)

        var blockLazy = (/blocklazy/gi).test(window.location.href);
        
        return (
            <div>
                <Helmet>
                    <title>Startup Guide - {seo.title?seo.title:name}</title>
                    <meta content={seo.description?seo.description:name} name="description" />
                    <meta content="website" property="og:type" />

                    <meta content={social.generic[0]&&social.generic[0].title?social.generic[0].title:name} property="og:title" />
                    <meta content={social.generic[0]&&social.generic[0].image?social.generic[0].image:picture} property="og:image" />
                    <meta content={social.generic[0]&&social.generic[0].description?social.generic[0].description:name} property="og:description" />
                    <meta property="og:url" content={"https://startupguide.com/playbook/"+slug}></meta>
                    <meta property="og:site_name" content="StartupGuide"></meta>


                    <meta name="twitter:card" content={social.twitter[0]&&social.twitter[0].type.includes('Standard')?'summary':'summary_large_image'}></meta>
                    <meta name="twitter:site" content="@StartupGuideHQ"></meta>
                    <meta name="twitter:creator" content={social.twitter[0]&&social.twitter[0].handle?social.twitter[0].handle:'@StartupGuideHQ'}></meta>
                    <meta name="twitter:title" content={social.twitter[0]&&social.twitter[0].title?social.twitter[0].title:name}></meta>
                    <meta name="twitter:description" content={social.twitter[0]&&social.twitter[0].description?social.twitter[0].description:name}></meta>
                    <meta name="twitter:image" content={social.twitter[0]&&social.twitter[0].image?social.twitter[0].image:picture}></meta>
                </Helmet>
                <div className="section-6">
                    <div className="businessbackground" style={{ background: color }}>
                        <div className="category-selector">
                            <div className="category-tag">CATEGORY</div>
                            <div className="category-selector-dropdown w-dropdown-toggle">
                                <div className="business" style={{ textTransform: 'uppercase' }}>
                                    {name}
                                </div>
                            </div>
                            {/* TODO: Implement list of related categories
                            <div
                                data-delay={0}
                                className="dropdown w-dropdown"
                                onMouseEnter={() => this.setState({ isDropdownOpen: true })}
                                onMouseLeave={() => this.setState({ isDropdownOpen: false })}
                            >
                                <div className="category-selector-dropdown w-dropdown-toggle">
                                    <div className="business" style={{ textTransform: 'uppercase' }}>
                                        {name}
                                    </div>
                                    <img alt="" src={artboardImage} width={19} className="image-34" />
                                </div>
                                <nav
                                    className="dropdown-list-9 w-dropdown-list"
                                    style={{ display: this.state.isDropdownOpen ? 'block' : 'none' }}
                                >
                                    <a href="#" className="category-dropdown-link w-dropdown-link">Category 1</a>
                                    <a href="#" className="category-dropdown-link w-dropdown-link">Category 2</a>
                                    <a href="#" className="category-dropdown-link w-dropdown-link">Category 3</a>
                                    <a href="#" className="category-dropdown-link w-dropdown-link">Category 4</a>
                                    <a href="#" className="category-dropdown-link w-dropdown-link">Category 5</a>
                                    <a href="#" className="category-dropdown-link lastone w-dropdown-link">
                                        See all categories
                                    </a>
                                </nav>
                            </div>
                            */}
                        </div>
                    </div>
                </div>
                <div className="page-heading">
                    <div className="subcategories-row w-hidden-small w-hidden-tiny">
                        <div className="category-content-navigation">
                            <div className="links-container-category">
                                {subcategories.map((s, k) =>
                                    <Link to={s.link} className="internal-page-link subcategory">
                                        {s.name}
                                    </Link>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                { !blockLazy &&
                <LazyLoad offsetVertical={100} debounce={false}>
                    <div id="recent-posts" className="recentcategory-posts">
                        <div className="business-row">
                            {Array(this.state.rows).fill().map((_, r) =>
                                <div key={r} className="row-business w-row">
                                    {articles.slice(3 * r, 3 * r + 3).map((a, k) =>
                                        <ArticlePreview key={k} { ...a } color={color} parentCategory={slug}/>
                                    )}
                                </div>
                            )}
                            <div className="discover-berlin w-container">
                                <a
                                    data-w-id="72028f29-0ac2-fd2f-c466-6ae180529edb"
                                    className="discover-more-category busines w-button"
                                    style={{
                                        display: canLoadMore ? 'block' : 'none',
                                        borderColor: color,
                                        background: this.state.isHoverDiscoverMore ? '#ffffff' : color,
                                        color: this.state.isHoverDiscoverMore ? color : '#ffffff',
                                    }}
                                    onClick={() => this.setState({ rows: this.state.rows + 1 })}
                                    onMouseEnter={() => this.setState({ isHoverDiscoverMore: true })}
                                    onMouseLeave={() => this.setState({ isHoverDiscoverMore: false })}
                                >
                                    DISCOVER&nbsp;MORE
                                </a>
                            </div>
                            {/* TODO: Implement featured articles
                            <div className="row-business w-row">
                                <div data-w-id="37618aac-9a46-3e70-16c8-287b52302c5d" className="column-35 w-col w-col-6 w-col-medium-4"><img alt="" src="images/image-19-9-placeholder.svg" className="image-headline primary" />
                                    <div data-w-id="5d0caf96-2a22-0192-6340-8e7f21889ce0" style={{display: 'block'}} className="div-block-46">
                                        <div className="text-block-49">SUBCATEGORY</div>
                                    </div>
                                    <div className="div-block-16 busines" />
                                    <div className="div-block-47">
                                        <h3 className="heading-9 healines_main">
                                            <strong className="featured_headline">London vs. Berlin: which is better for startups?</strong></h3>
                                        <p className="paragraph-3">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. </p>
                                    </div>
                                    <div className="div-block-15">
                                        <div className="grey">Zamira Racher</div><img alt="" src="images/grey_time.svg" width={13} height={13} className="image-24" />
                                        <div className="grey2">3' read</div><img alt="" src="images/sound.svg" height={16} className="image-27" /></div>
                                    <div className="grey2">3' listen</div>
                                </div>
                            </div>
                            */}
                        </div>
                    </div>
                </LazyLoad>
                }
                { blockLazy &&
                    <div id="recent-posts" className="recentcategory-posts">
                        <div className="business-row">
                            {Array(this.state.rows).fill().map((_, r) =>
                                <div key={r} className="row-business w-row">
                                    {articles.slice(3 * r, 3 * r + 3).map((a, k) =>
                                        <ArticlePreview key={k} { ...a } color={color} parentCategory={slug}/>
                                    )}
                                </div>
                            )}
                            <div className="discover-berlin w-container">
                                <a
                                    data-w-id="72028f29-0ac2-fd2f-c466-6ae180529edb"
                                    className="discover-more-category busines w-button"
                                    style={{
                                        display: canLoadMore ? 'block' : 'none',
                                        borderColor: color,
                                        background: this.state.isHoverDiscoverMore ? '#ffffff' : color,
                                        color: this.state.isHoverDiscoverMore ? color : '#ffffff',
                                    }}
                                    onClick={() => this.setState({ rows: this.state.rows + 1 })}
                                    onMouseEnter={() => this.setState({ isHoverDiscoverMore: true })}
                                    onMouseLeave={() => this.setState({ isHoverDiscoverMore: false })}
                                >
                                    DISCOVER&nbsp;MORE
                                </a>
                            </div>
                            {/* TODO: Implement featured articles
                            <div className="row-business w-row">
                                <div data-w-id="37618aac-9a46-3e70-16c8-287b52302c5d" className="column-35 w-col w-col-6 w-col-medium-4"><img alt="" src="images/image-19-9-placeholder.svg" className="image-headline primary" />
                                    <div data-w-id="5d0caf96-2a22-0192-6340-8e7f21889ce0" style={{display: 'block'}} className="div-block-46">
                                        <div className="text-block-49">SUBCATEGORY</div>
                                    </div>
                                    <div className="div-block-16 busines" />
                                    <div className="div-block-47">
                                        <h3 className="heading-9 healines_main">
                                            <strong className="featured_headline">London vs. Berlin: which is better for startups?</strong></h3>
                                        <p className="paragraph-3">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. </p>
                                    </div>
                                    <div className="div-block-15">
                                        <div className="grey">Zamira Racher</div><img alt="" src="images/grey_time.svg" width={13} height={13} className="image-24" />
                                        <div className="grey2">3' read</div><img alt="" src="images/sound.svg" height={16} className="image-27" /></div>
                                    <div className="grey2">3' listen</div>
                                </div>
                            </div>
                            */}
                        </div>
                    </div>
                }
            </div>
        )
    }
}

const connectRelay = CategoryPage => class extends Component {

    render() {
        const { routeResolver } = this.props.context
        const subArticles = this.props.category.subcategories
            .map(s => s.articles)
            .reduce((a, b) => a.concat(b), [])

        const props = {
            slug: this.props.category.slug,
            name: this.props.category.name,
            color: this.props.category.color,
            picture: this.props.category.picture,
            link: routeResolver.category.get(this.props.category.slug),
            subcategories: this.props.category.subcategories.map(c => ({
                ...c,
                link: routeResolver.category.get(c.slug),
            })),
            articles: this.props.category.articles.concat(subArticles).map(a => ({
                ...a,
                link: routeResolver.article.get(!a.category || a.category.slug, a.slug),
            })),
            seo: this.props.category.seo,
            social: this.props.category.social,
        }

        return <CategoryPage {...props} />
    }
}

export default createFragmentContainer(
    connectRelay(CategoryPage),
    graphql`
        fragment categoryPage_category on Category {
            slug
            name
            color
            picture
            subcategories {
                slug
                name
                articles(first: 60) {
                    slug
                    title
                    caption
                    readingTime
                    picture
                    author {
                        firstname
                        lastname
                    }
                    category {
                        slug
                        name
                    }
                }
            }
            seo {
                title
                description
            }
            social {
                twitter {
                    type
                    title
                    image
                    handle
                    description
                }
                generic {
                    title
                    description
                    image
                }
            }
            articles(first: 60) {
                slug
                title
                caption
                readingTime
                picture
                author {
                    firstname
                    lastname
                }
                category {
                    slug
                    name
                }
            }
        }
    `
)
